import { COUNTRY_SETTINGS } from '@de-care/shared/configuration-tokens-locales';

export function provideCountryConfig({
    countryCode,
}: {
    countryCode: 'us' | 'ca';
}) {
    return [
        {
            provide: COUNTRY_SETTINGS,
            useValue: { countryCode },
        },
    ];
}
